import { getLocale } from 'next-intl/server';
import { localeToLang } from '@/shared/i18n/localeToLang';
import { getLocalizedValue } from '@/shared/lib/getLocalizedValue';
import { loadConfig } from './loadConfig';
import { withOrderPageFallback } from './page';

export type PageTitle = 'home' | 'cart' | 'order' | 'alergens' | 'contact' | 'product-detail' | 'blog-detail';

export const replaceParams = (url: string, params: Record<string, string>) => {
    return url.replace(/\[([^\]]+)\]/g, (_match: string, paramName: string) => {
        return params[paramName] ?? _match;
    });
};

export const getStaticPageUrl = async (page: PageTitle, params?: Record<string, string>) => {
    const locale = localeToLang(await getLocale());
    const config = await loadConfig();
    const pages = withOrderPageFallback(config?.pages);
    let url = getLocalizedValue(pages?.[page]?.metadata?.url, locale, true) || '#';

    if (!url) {
        return url;
    }

    if (params) {
        url = replaceParams(url, params);
    }

    return url;
};
